import {DEFAULT_LAYOUT_STYLE} from "@/configs/constants/ThemeConstants";

export interface ThemeState {
    navCollapsed: boolean;
    dataHover: boolean;
    topNavCollapsed: boolean;
    layoutStyle: string;
}

export const THEME_CONFIG = {
	navCollapsed: false,
	dataHover: true,
	topNavCollapsed: false,
	layoutStyle: DEFAULT_LAYOUT_STYLE,
};
